import { Referrer, referrerEvent } from "./referrer"

const logEvent = (eventName: string, eventProperties?: Record<string, any>) => {
  if (process.env.NODE_ENV === "development") {
    console.log("analytics.logEvent", eventName, eventProperties)
  } else {
    window.gtag("event", eventName, eventProperties)
  }
}

const locationToUtm = (location: any) => {
  const params = new URLSearchParams(location.search)
  const source = params.get("utm_source")
  const medium = params.get("utm_medium")
  if (!source && !medium) {
    const referrer = referrerEvent()
    if (referrer) {
      return {
        source: referrer.utmSource,
        medium: referrer.utmMedium,
        campaign: null,
      }
    }
  }
  const campaign = params.get("utm_campaign")
  return { source, medium, campaign }
}

export const onViewArticle = ({
  location,
  id,
}: {
  location: any
  id: string
}) => {
  const utm = locationToUtm(location)
  logEvent("ViewMediaColumn", {
    ColumnID: id,
    UtmSource: utm.source,
    UtmMedium: utm.medium,
    UtmCampaign: utm.campaign,
  })
}

export const onClickArticleContentAd = ({
  id,
  adTitle,
  adUrl,
}: {
  id: string
  adTitle: string
  adUrl: string
}) => {
  logEvent("ClickMediaColumnContentAd", {
    ColumnID: id,
    AdName: adTitle,
    AdURL: adUrl,
  })
}

export const onClickAddFriend = ({
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
}: Referrer) => {
  try {
    if (process.env.NODE_ENV === "development") {
      console.log("analytics.logEvent", "ClickAddFriend")
    } else {
      window.fbq("track", "CompleteRegistration")
      window.gtag("event", "conversion", {
        send_to: "AW-11070125325/7m1qCPWTsogYEI3q0p4p",
      })
      logEvent("ClickAddFriend", {
        UtmSource: utmSource,
        UtmMedium: utmMedium,
        UtmCampaign: utmCampaign,
        UtmContent: utmContent,
      })
    }
  } catch (e) {
    console.error(e)
  } finally {
    // NOTE: stagingは以下に飛ばすようにする
    // const liffId = "1621109803-8Ywpdj9J"
    const liffId = "1572434118-WDRaanXQ"
    const url = `https://liff.line.me/${liffId}?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&utm_content=${utmContent}`
    window.location.href = url
  }
}

export const onClickLinkToAppStore = (type: "directApple" | "directGoogle" | "onelink", {
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
}: Referrer) => {
  try {
    if (process.env.NODE_ENV === "development") {
      console.log("analytics.logEvent", "ClickLinkToAppStore")
    } else {
      window.fbq("track", "CompleteRegistration")
      window.gtag("event", "conversion", {
        send_to: "AW-11070125325/7m1qCPWTsogYEI3q0p4p",
      })
      logEvent("ClickInstallApp", {
        UtmSource: utmSource,
        UtmMedium: utmMedium,
        UtmCampaign: utmCampaign,
        UtmContent: utmContent,
      })
    }
  } catch (e) {
    console.error(e)
  } finally {
    const url = (() => {
      switch (type) {
      case "directApple":
        return `https://apps.apple.com/jp/app/%E3%83%9A%E3%82%A2%E3%82%B1%E3%82%A2/id6502973731`
      case "directGoogle":
        return `https://play.google.com/store/apps/details?id=jp.entale.paircare`
      case "onelink":
        return `https://paircare.onelink.me/tFUS?af_xp=custom&af_dp=paircare%3A%2F%2F&pid=Paircare_Lp${utmSource ? "_"+utmSource : ""}&af_channel=${utmMedium}&c=${utmCampaign}&af_ad=${utmContent}&af_sub1=${utmSource}&af_sub2=${utmMedium}&af_sub3=${utmCampaign}&af_sub4=${utmContent}`
      }
    })()
    window.location.href = url
  }
}

// // アプリのダウンロードボタンをクリック
// export const trackClickInstallApp = () => {
//   if (import.meta.env.VITE_APP_ENV !== "production") {
//     console.log("ad.trackClickInstallApp")
//     return
//   }
//   window.fbq("track", "CompleteRegistration")
//   window.ttq.track("CompleteRegistration")
//   window.twq("event", "tw-omanf-omaq4", {})
//   event("conversion", {
//     "send_to": "AW-11070125325/7m1qCPWTsogYEI3q0p4p",
//   })
// }

// const logEventClickInstallApp = (tr: Tracking) => {
//   logEvent("ClickInstallApp", {
//     UtmSource: tr.utmSource,
//     UtmMedium: tr.utmMedium,
//     UtmCampaign: tr.utmCampaign,
//   })
// }

export const onViewRegistrationModal = ({
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
}: Referrer) => {
  logEvent("ViewRegistrationModal", {
    UtmSource: utmSource,
    UtmMedium: utmMedium,
    UtmCampaign: utmCampaign,
    UtmContent: utmContent,
  })
}

export const onClickCloseRegistrationModal = ({
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
}: Referrer) => {
  logEvent("ClickCloseRegistrationModal", {
    UtmSource: utmSource,
    UtmMedium: utmMedium,
    UtmCampaign: utmCampaign,
    UtmContent: utmContent,
  })
}
